<!--  eslint-disable vue/no-mutating-props -->
<template>
  <input
    id="username"
    v-model="value"
    class="form-control"
    type="text"
    :maxlength="schema.max"
    :placeholder="schema.placeholder"
    :readonly="schema.readonly"
    @blur="onBlur"
  />
</template>

<script>
import VFG from "vue-form-generator";

export default {
  mixins: [VFG.abstractField],
  props: {
    value: {
      type: String,
      default: () => ""
    }
  },
  methods: {
    onBlur() {
      this.validate();
    }
  }
};
</script>
